import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import WordNavigation from 'components/vocab/word_navigation';
import { loadWorksheetWordIds } from 'utils/worksheet_navigation';

export default function WorksheetWordNavigation() {
  const { worksheetId, wordId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const context = location.state?.worksheetNavigation;
  const [navigation, setNavigation] = useState({ loading: true, wordIds: [] });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const savedContext = context?.worksheetId === worksheetId ? context : null;
    if (savedContext?.wordIds) {
      setNavigation({ loading: false, wordIds: savedContext.wordIds });
      return;
    }
    setNavigation({ loading: true, wordIds: [] });
    loadWorksheetWordIds({
      worksheetId,
      filters: savedContext?.filters || {},
      sort: savedContext?.sort,
    }, () => cancelled).then(wordIds => {
      if (!cancelled) setNavigation({ loading: false, wordIds });
    }).catch(() => {
      if (!cancelled) setNavigation({ loading: false, wordIds: [], error: true });
    });
    return () => { cancelled = true; };
  }, [worksheetId, context, attempt]);

  const position = navigation.wordIds.indexOf(wordId);
  const adjacent = direction => position >= 0 && navigation.wordIds[position + direction];
  const navigateWord = direction => {
    const nextWordId = adjacent(direction);
    if (navigation.loading || !nextWordId) return;
    navigate({
      pathname: `${location.pathname.replace(/\/[^/]+\/?$/, '')}/${encodeURIComponent(nextWordId)}`,
      search: location.search,
    }, {
      state: {
        ...location.state,
        worksheetNavigation: { ...context, worksheetId, wordIds: navigation.wordIds },
      },
    });
  };

  return (
    <>
      <WordNavigation
        label='Worksheet vocabulary navigation'
        loading={navigation.loading}
        canNavigate={adjacent}
        onNavigate={navigateWord}
      />
      {navigation.error && (
        <div role='alert' style={{ paddingTop: 32 }}>
          Couldn’t load worksheet words. <button type='button' onClick={() => setAttempt(attempt + 1)}>Try again</button>
        </div>
      )}
    </>
  );
}
